import { UserRole } from "@prisma/postgresClient";

export default UserRole;
